import { useTheme } from "@mui/material";
import { GeoJSON } from "react-leaflet";

import { useSearchSelected } from "../../hooks/searchHooks";

export function SearchedLayer() {
  const [{ selected, geometry }] = useSearchSelected();
  const theme = useTheme();

  if (!geometry) return null;

  return (
    <GeoJSON
      key={selected}
      data={geometry}
      style={{
        fill: true,
        fillColor: theme.palette.primary.main,
        fillOpacity: 0.3,
        stroke: true,
      }}
    />
  );
}
